import type { SelectTagOption } from 'src/library/editors/elements/select-tag-option';
import type { PersonForAccessControl } from 'src/models/pages/person-for-access-control';

/**
 * Bygger valgene i beredskapstilgangs-velgeren.
 *
 * getPeopleForAccessControl merker den innloggede brukeren som disabled slik at
 * man ikke kan fjerne sin egen tilgang. Den sperren skal bare gjelde når man
 * faktisk HAR tilgang – ellers kan verken eier eller beredskapsansvarlig gi seg
 * selv tilgang, og en tom liste kan aldri bootstrappes (veileder 196188 ber
 * nettopp om at man gir seg selv tilgang).
 */
export function emergencyAccessPeople(
  people: PersonForAccessControl[],
  accessList: string[],
): (SelectTagOption & { disabled: boolean })[] {
  return people.map((person) => {
    return {
      value: person.id,
      text: person.value,
      disabled: person.disabled && accessList.includes(person.id),
    };
  });
}
